<template>
    <div class="profile-dashboard__desk-facilities">
        <div class="profile-dashboard__desk-facilities-list" v-if="facilitiesComputed.length && loaded">

            <div class="profile-dashboard__desk-facilities-track">
                <div class="profile-dashboard__desk-facilities-item" v-for="(item,idx) in facilitiesComputed">

                    <donor v-if="'is_donor' in item" :donor="item" :weight="item.weight" :index="idx"/>
                    <homestay v-else-if="'view_mode' in item" :homestay="item" :index="idx"/>
                    <helps v-else :facility="item" :index="idx"/>

                </div>
            </div>

            <div class="profile-dashboard__desk-facilities-more"
                 v-if="donors.length || homestays.length || helps.length || page < donorsPages || page < homestaysPages || page < helpsPages">
                <span class="lnr lnr-chevron-down" @click.prevent="nextStep(3)"></span>
            </div>

        </div>
        <div v-else-if="!loaded" class="profile-dashboard__desk-facilities-list">
            <div class="profile-dashboard__desk-facilities-item profile-dashboard__desk-facilities-item--empty d-flex">
                <div class="LoaderBalls">
                    <div class="LoaderBalls__item"></div>
                    <div class="LoaderBalls__item"></div>
                    <div class="LoaderBalls__item"></div>
                </div>
            </div>
        </div>
        <div v-else class="profile-dashboard__desk-facilities-list">
            <div class="profile-dashboard__desk-facilities-item profile-dashboard__desk-facilities-item--empty d-flex">
                {{$store.getters.t('facilities_list_empty')}}
            </div>
        </div>

    </div>
</template>

<script>

import Donor from './UserDashboardFacilitiesDonor'
import Homestay from './UserDashboardFacilitiesHomestays'
import Helps from './UserDashboardFacilitiesHelps'

export default {
    name: "UserDashboardFacilities",
    props: ['user'],
    components: {Donor, Homestay, Helps},
    data() {
        return {
            donorsPages: 1,
            homestaysPages: 1,
            helpsPages: 1,
            page: 1,

            loaded: false,

            donors: [],
            homestays: [],
            helps: [],

            facilities: [],

            endpoints: {
                donors: '/donors',
                homestays: `/api/homestays`,
                helps: `/api/facilities`,
            },
            arrays: ['donors', 'homestays', 'helps'],
        }
    },

    async mounted() {
        await this.getFacilities()
    },

    watch: {
        facilitiesComputed() {
            this.loaded = false

            setTimeout(() => {
                this.loaded = true
            }, 500)

        },


    },

    computed: {

        facilitiesComputed() {

            let arr = this.facilities

            if ( ! arr.length ) arr = []

            return arr

        },

    },

    methods: {

        async nextStep( _count = 0 ) {

            const [ _D, _HS, _H ]  = this.arrays // ['donors', 'homestays', 'helps']

            if ( this[ _D ].length  +  this[ _H ].length  +  this[ _HS ].length  <  _count ) {

                if ( this[`${ _D }Pages`]  >  this.page  ||  this[`${ _HS }Pages`]  >  this.page  ||  this[`${ _H }Pages`]  >  this.page ) {

                    this.page += 1;

                    await this.getFacilities()

                    return;

                }

            }

            const _prepareArray = [];

            for( const _a  of  this.arrays ){

                if (this[ _a ].length && _count > 0) {

                    _prepareArray.push( this[ _a ].pop() );

                    _count -= 1;

                }

            }

            this.facilities = await ( () => ( [ ...this.facilities, ..._prepareArray ] ) )()

            if ( +this.facilities.length  %  3  !==  0 ) {

                if ( this[ _D ].length  ||  this[ _H ].length  ||  this[ _HS ].length ) {

                    await this.nextStep( _count )

                }

            }

        },

        async getFacilities() {

            for ( const _a  of  this.arrays ) {

                if (this.page <= this[ `${_a}Pages` ]) {

                    try{

                        const {data} = await this.getDataForArray( _a );

                        if( data.data.length ){

                            this[ _a ] = await ( () => ( [ ...data.data.reverse(), ...this[ _a ] ] ) )();

                            this[ `${ _a }Pages` ] = data.meta.last_page;

                        }

                    } catch ( _e ){

                        console.log( _e )

                    }



                }

            }

            return await this.nextStep( 3 )

        },

        async getDataForArray( _array ) {

            const params = {
                page: this.page,
                per_page: 3,
                user_id: this.user.id
            }

            try {

                const  _res  = await axios.get( this.endpoints[ _array ], { params: params } );

                return _res


            } catch ( _e ) {

                console.log( _e )

            }


        },


    }
}
</script>

<style lang="scss" scoped>
.LoaderBalls {
    margin: 0 auto;
    width: 90px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    &__item {
        $anim-drt: 0.3s;
        $anim-ease: cubic-bezier(.6, .05, .15, .95);
        width: 20px;
        height: 20px;
        border-radius: 50%;
        background: #2E76E4;

        &:nth-child(1) {
            animation: bouncing $anim-drt alternate infinite $anim-ease;
        }

        &:nth-child(2) {
            animation: bouncing $anim-drt $anim-drt/4 alternate infinite $anim-ease backwards;
        }

        &:nth-child(3) {
            animation: bouncing $anim-drt $anim-drt/2 alternate infinite $anim-ease backwards;
        }
    }
}


@keyframes bouncing {

    0% {
        transform: translate3d(0, 10px, 0) scale(1.2, 0.85);
    }

    100% {
        transform: translate3d(0, -20px, 0) scale(0.9, 1.1);
    }
}
</style>
